import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { PipeModule } from '@shared/pipe/pipe.module';

interface DialogData {
  videoId: string;
}

@Component({
  selector: 'app-youtube-dialog',
  imports: [MatDialogModule, PipeModule],
  templateUrl: './youtube-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './youtube-dialog.component.scss'
})
export class YoutubeDialogComponent {
  public dialogRef = inject(MatDialogRef<YoutubeDialogComponent>);
  public data = inject<DialogData>(MAT_DIALOG_DATA);

  
}
